import { Elevations } from "@oui/system/elevation"

const elevations: Elevations = {
  none: "none",
  xs: "1px 1px 1px 1px rgba(0,0,0,0.15)",
  sm: "2px 2px 2px 2px rgba(0,0,0,0.15)",
  md: "4px 4px 4px 4px rgba(0,0,0,0.15)",
  lg: "6px 6px 6px 6px rgba(0,0,0,0.15)",
  xl: "8px 8px 8px 8px rgba(0,0,0,0.15)",
  xxl: "10px 10px 10px 10px rgba(0,0,0,0.15)"
}

export default elevations
